import Config from '@/config'

function addDesignerForm() {
  const script = document.createElement('script')
  script.classList.add('stepform_1IAuXoR', 'rnd_524321032')
  script.innerText = `
(function(s, t, e, p, f, o, r, m) {
    s[t] = s[t] || {};
    s[t][524321032] = {
        id: "1IAuXoR",
        rnd: 524321032,
        popup: true,
        showType: "auto",
        autoDelay: "timeout",
        autoDelayTime: 120,
        autoInterval: "session",
        stopLead: true,
        preload: true,
        overlayColor: "00AFA1",
        overlayOpacity: 70
    };
    e.async = true;
    e.src = p + f;
    document[m](o)[r](e)
}(window,"stepFORM_params",document.createElement("script"),document.location.protocol==="https:"?"https:":"http:","//u011166.stepform.io/api.js?id=1IAuXoR","head","appendChild","querySelector"));
  `
  document.body.appendChild(script)
}

async function showDesignerForm(vm) {
  const isManufacturer = localStorage.getItem('isManufacturer') === 'true'
  let isAuthorized = false
  try {
    await vm.$user.fetchContext()
    isAuthorized = true
  }
  catch (error) {}
  if (!isManufacturer && isAuthorized) {
    addDesignerForm()
  }
}

export {
  showDesignerForm
}
